import { useBaseUrlStore, useLabels } from 'src/StoreDataProvider';
import { TitleProps } from './title.types';

const Title: (props: TitleProps) => JSX.Element = ({ isH1 = true }) => {
  const labels = useLabels();
  const { isYearView } = useBaseUrlStore();
  const DynamicTag = isH1 ? 'h1' : 'div';

  return (
    <section id="title" style={{ display: 'block' }}>
      <DynamicTag
        className="title"
        lang={
          isYearView
            ? labels.titleYearsViewLanguage
            : labels.titleDefaultViewLanguage
        }
      >
        <span className="title__main">
          {isYearView ? labels.titleYearsView1 : labels.titleDefaultView1}
        </span>
        <span className="title__dot">
          {isYearView ? labels.titleYearsView2 : labels.titleDefaultView2}
        </span>
        <span className="title__sub">
          {isYearView ? labels.titleYearsView3 : labels.titleDefaultView3}
        </span>
      </DynamicTag>
    </section>
  );
};

export default Title;
